import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import HomePage from './pages/HomePage';
import MeasurementPage from './pages/MeasurementPage';
import TryOnPage from './pages/TryOnPage';
//import TryOnDemo from './pages/TryonDemo';
import SkinAnalysis from './pages/SkinTone';
import './App.css';
import logo from './logo_3.png';
import GarmentAnalyzer from './components/GarmentAnalyzer';
import FashionRecommendation from './components/FashionRecommendation';

function App() {
  return (
    <AppProvider>
      <Router>
        <div className="app-container">
          <header className="app-header">
            <div className="logo-container">
              <img src={logo} alt="Haute-U AR Technologies" className="logo" />
              <h1>Haute-U AR Technologies</h1>
            </div>
            <nav className="nav-bar">
              <Link to="https://hauteuar.com" className="nav-button">HOME</Link>
              <Link to="/fashion-recommendation" className="nav-button">Fashion Recommendation</Link>
              <Link to="/skintone" className="nav-button">Skin Tone Analyzer</Link>
              {/* <Link to="/tryon-demo" className="nav-button">Try-On Demo</Link> */ }
              <Link to="/measurements" className="nav-button">My Measurements</Link>
              <Link to="/try-on" className="nav-button">Virtual Try-On</Link>
           
              
              <Link to="/garment-analyzer" className="nav-button">Garment Analyzer</Link>
              
              
            </nav>
          </header>

          <main className="app-content">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/measurements" element={<MeasurementPage />} />
              <Route path="/try-on" element={<TryOnPage />} />
              <Route path="/skintone" element={<SkinAnalysis />} />
              { /* <Route path="/tryon-demo" element={<TryOnDemo />} /> */}
              <Route path="/garment-analyzer" element={<GarmentAnalyzer />} />
              <Route path="/fashion-recommendation" element={<FashionRecommendation />} />
            </Routes>
          </main>

          <footer className="app-footer">
            <p>&copy; {new Date().getFullYear()} Haute-U AR Technologies</p>
          </footer>
        </div>
      </Router>
    </AppProvider>
  );
}

export default App;
